import { inject as service } from '@ember/service';
import TransactionalBaseMetricsController from 'cio/pods/transactional/message/overview/base-metrics-controller';
import AuthService from 'cio/services/auth';

export default class TransactionalMessageOverviewMetricsController extends TransactionalBaseMetricsController {
  @service auth!: AuthService;
}

declare module '@ember/controller' {
  interface Registry {
    'transactional.message.overview.metrics': TransactionalMessageOverviewMetricsController;
  }
}
